import React, { useRef, cloneElement, ReactElement } from 'react'
import { Tooltip, TooltipProps } from '@mui/material'
import { useIsOverflowing } from '../../hooks/useIsOverflowing'

interface OverflowTooltipWrapperProps extends Omit<TooltipProps, 'children'> {
    children: ReactElement & { ref?: React.Ref<any> }
    isMultiline?: boolean
    /** Shows the tooltip whether or not the text is cut off, for a title that says more. */
    isAlwaysShown?: boolean
}

const ENTER_DELAY_MS = 1000

export const OverflowTooltipWrapper: React.FC<OverflowTooltipWrapperProps> = ({
    children,
    isMultiline = false,
    isAlwaysShown = false,
    ...tooltipProps
}) => {
    const elementRef = useRef(null)
    const isOverflowing = useIsOverflowing(elementRef, isMultiline)

    const childWithRef = cloneElement(children, {
        ref: elementRef,
        ...(isMultiline ? {} : { noWrap: true }),
    })

    return (
        <Tooltip
            enterDelay={ENTER_DELAY_MS}
            enterNextDelay={ENTER_DELAY_MS}
            {...tooltipProps}
            disableHoverListener={!isAlwaysShown && !isOverflowing}
        >
            {childWithRef}
        </Tooltip>
    )
}
